import React, { useEffect,useContext } from "react"
import { Grid, Typography} from "@material-ui/core"
import AircraftMakeAutocomplete from "./AircraftMakeAutocomplete";
import AircraftModelAutocomplete from "./AircraftModelAutocomplete";
import AircraftYearAutocomplete from "./AircraftYearAutocomplete";
import InsuredValueField from "./InsuredValueField";
import { ControlledTextRadioController } from "../../Core/Form/Radio";
import { ControlledCheckBox } from "../../Core/Form/CheckBox";
import AircraftSeatsField from './AircraftSeatsField';
import { useFormContext } from 'react-hook-form';
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';


const AircraftDetailsSection = () => {
    const { reset, watch, getValues } = useFormContext();
    const notFound = watch('make_model_not_found');
    const {locked_quote} = useContext(QuoteContextStore)

    useEffect(() => {
        reset({...getValues(), make:"", model: "", year: "", min_value: 0, max_value: 550000})
    }, [notFound]);

    return (
    <Grid container item md={12} lg={9} spacing={4}>
        <Grid item xs={12} md={5}>
            <AircraftMakeAutocomplete />
        </Grid>
        <AircraftModelAutocomplete />
        <AircraftYearAutocomplete />
        <Grid item xs={12} >
            <ControlledCheckBox name="make_model_not_found" label="I can’t find my aircraft on the list"/>
        </Grid>
        <Grid item xs={12} md={6}>
            <InsuredValueField />
            <ControlledCheckBox name="allow_hull" label="I want physical damage coverage (Hull)" disabled={locked_quote}/>
        </Grid>
        <Grid item xs={12} md={6}>
            <Typography variant="h4" className="gray">Total seats</Typography>
            <AircraftSeatsField />
            <ControlledTextRadioController name="is_hangared" options={[{label: "Yes", value: "true"}, {label: "No", value: "false"}]} disabled={locked_quote}>
                <Typography variant="body" className="gray">Is your aircraft hangared?</Typography>
            </ControlledTextRadioController>
        </Grid>
    </Grid>
    )
}

export default AircraftDetailsSection;